const priceFormatter = new Intl.NumberFormat('ja-JP', {
  style: 'currency',
  currency: 'JPY',
})

export default function price(value: number): string {
  return priceFormatter.format(value)
}
